export enum DepreciationMethod {
  None = 'None',
  StraightLine = 'StraightLine',
  DecliningBalance200 = 'DecliningBalance200',
  DecliningBalance150 = 'DecliningBalance150',
  SumOfYearsDigits = 'SumOfYearsDigits',
  UnitsOfProduction = 'UnitsOfProduction'
}

// Posting/convention for aggregating depreciation
export enum ProrateConvention {
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  BiAnnual = 'BiAnnual',
  Annual = 'Annual',
}

export interface DepreciationScheduleEntryModel {
  periodStart: string; // ISO date
  periodEnd: string;   // ISO date
  periodNumber: number;
  depreciationAmount: number;
  accumulatedDepreciation: number;
  endingBookValue: number;
}

// Batch MACRS computation result types
export interface MacrsPeriodAmount {
  periodStart: string; // ISO date (start of period)
  periodEnd: string;   // ISO date (end of period)
  amount: number | null; // MACRS amount for the period; null when not applicable
  meta?: {
    yearIndex?: number;
    note?: string;
  };
}

export interface MacrsBatchResult {
  periods: MacrsPeriodAmount[];
}

export interface DisposalModel {
  disposed: boolean;
  disposalDate?: string; // ISO date
  proceeds?: number; // sale proceeds (Disposal Amount)
  expenses?: number; // Disposal Expenses
  entryDate?: string; // ISO date when disposal JE was posted
  gainLoss?: number; // computed (mock)
}
